const actions = {
  SET_STATE: 'payouts/SET_STATE',
  FETCH_ALL_PAYOUTS: 'payouts/FETCH_ALL_PAYOUTS',
  FETCH_PAYOUT_DETAIL: 'payouts/FETCH_PAYOUT_DETAIL',
}

export default actions
